export const emptyCustomerForm = {
  name: '',
  organizationName: '',
  email: '',
  phone: '',
  address: ''
};

export function customerFormFromRecord(customer) {
  return {
    name: customer?.name || '',
    organizationName: customer?.organization_name || '',
    email: customer?.email || '',
    phone: customer?.phone || '',
    address: customer?.address || ''
  };
}

export function buildCustomerPayload(formData) {
  return {
    name: formData.name.trim(),
    organizationName: formData.organizationName.trim() || null,
    email: formData.email.trim() || null,
    phone: formData.phone.trim() || null,
    address: formData.address.trim() || null
  };
}
